export enum CampaignRouteNameEnum {
	list = "campaigns.list",
	locations = "campaigns.locations",
	item = "campaigns.item",
	orderDetails = "campaigns.orderDetails",
	reservedOrderDetails = "campaigns.reservedOrderDetails",
}
